import axios from "axios";
import { API } from "./helpers";

const trackEvent = (eventType, metadata = {}) => {
  const userId = localStorage.getItem("relixdata_user_email") || "anonymous";
  axios.post(`${API}/analytics/track`, {
    event_type: eventType,
    user_id: userId,
    metadata,
  }).catch(() => {});
};

export const trackSearch = (location) => trackEvent("search", { location });
export const trackAnalysisView = (propertyId) => trackEvent("analysis_view", { property_id: propertyId });
export const trackSaveProperty = (propertyId) => trackEvent("save_property", { property_id: propertyId });
export const trackShareProperty = (propertyId) => trackEvent("share_property", { property_id: propertyId });
export const trackPageView = (page) => trackEvent("page_view", { page });
export const trackSignup = () => trackEvent("signup");
export const trackOnboardingComplete = (prefs) => trackEvent("onboarding_complete", prefs);

export default trackEvent;
